import { render } from "./CategoryEditModalPopup.vue?vue&type=template&id=03921328&scoped=true"
import script from "./CategoryEditModalPopup.vue?vue&type=script&lang=js"
export * from "./CategoryEditModalPopup.vue?vue&type=script&lang=js"

import "./CategoryEditModalPopup.vue?vue&type=style&index=0&id=03921328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03921328"]])

export default __exports__